import { GenericService } from '../GenericService'

class CompanyService extends GenericService {
    constructor() {
        super('/api/admin/company')
    }

    getSingleRecord = (id) => this.get('/api/admin/company/getSingle/' + id)
}

export default new CompanyService()
